import styled, { css } from 'styled-components';

export const TypeFilterContainer = styled.div`
  > div {
    margin: 0;
    padding: 0;
    flex-wrap: wrap;
  }

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    label {
      padding: 0 10px;
      height: 45px;

      &::after {
        display: none;
      }
    }

    .children-type {
      padding-left: 25px;
      position: relative;

      &::before {
        left: 10px;
        position: absolute;
        content: '•';
        color: ${({ theme }) => theme.colors.text.primary};
        margin-right: 8px;
        font-size: 16px;
      }
    }
  }
`;

export const popoverStyles = css`
  padding: 15px 5px;
`;
